/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import AppContainer from "../../Components/Structure/AppContainer";
import ajaxBank from "../../util/remote/ajaxBank";
import MMChargesToday from "../../Components/Transactions/MMChargesToday";
import MMChargesTotal from "../../Components/Transactions/MMChargesTotal";
import MMChargesList from "../../Components/Transactions/MMChargesList";
import SchoolDepositChargesTotal from "../../Components/Transactions/SchoolDepositChargesTotal";
import VendorWithdrawCharges from "../../Components/Transactions/VendorWithdrawCharges";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function MMChargesPage() {
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);
    const [loading6, setLoading6] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [schoolStartDate, setSchoolStartDate] = useState("");
    const [schoolEndDate, setSchoolEndDate] = useState("");
    const [vendorStartDate, setVendorStartDate] = useState("");
    const [vendorEndDate, setVendorEndDate] = useState("");
    const [mmChargesToday, setMMChargesToday] = useState(false);
    const [mmChargesTotal, setMMChargesTotal] = useState(false);
    const [schoolCharges, setSchoolCharges] = useState(false);
    const [vendorCharges, setVendorCharges] = useState(false);

    const [withdrawChargeBalance, setWithdrawChargeBalance] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);

    useEffect(() => {
  const fetchAll = async () => {
    setLoadingPage(true);
    await Promise.all([
      getMMChargesToday(),
      startDate || endDate ? searchTotalMMCharges() : getTotalMMCharges(),
      schoolStartDate || schoolEndDate ? searchTotalSchoolCharges() : getTotalSchoolCharges(),
      vendorStartDate || vendorEndDate ? searchTotalVendorCharges() : getTotalVendorCharges(),
      getWithdrawChargeBalance(),
    ]);
    setLoadingPage(false);
  };

  fetchAll();
}, []);

    // useEffect(() => {
    //       if (startDate || endDate) {
    //           searchTotalMMCharges();
    //       } else {
    //           getTotalMMCharges();
    //       }
    //   }, []);

    // useEffect(() => {
    //       if (schoolStartDate || schoolEndDate) {
    //           searchTotalSchoolCharges();
    //       } else {
    //           getTotalSchoolCharges();
    //       }
    //   }, []);

    // useEffect(() => {
    //       if (vendorStartDate || vendorEndDate) {
    //           searchTotalVendorCharges();
    //       } else {
    //           getTotalVendorCharges();
    //       }
    //   }, []);

    // useEffect(() => {
    //         getMMChargesToday();
    //         getWithdrawChargeBalance();
    // }, []);

    const getTotalMMCharges = async () => {
      setLoading(true);
        const server_response = await ajaxBank.fetchMMChargesTotal();
        setLoading(false);
        if (server_response.status === "OK") {
          setMMChargesTotal(server_response.details);
        } else {
          setMMChargesTotal([]);
        }
    };

    const searchTotalMMCharges = async () => {
      setLoading2(true);
        const server_response = await ajaxBank.searchMMCharges(startDate, endDate);
        setLoading2(false);
        if (server_response.status === "OK") {
          setMMChargesTotal(server_response.details);
        } else {
          setMMChargesTotal([]);
        }
    };

    const getTotalSchoolCharges = async () => {
      setLoading3(true);
        const server_response = await ajaxBank.fetchTotalDepositChargesForSchools();
         
        setLoading3(false);
        if (server_response.status === "OK") {
          setSchoolCharges(server_response.details);
        } else {
          setSchoolCharges("404");
        }
    };

    const searchTotalSchoolCharges = async () => {
      setLoading4(true);
        const server_response = await ajaxBank.searchTotalDepositChargesForSchools(schoolStartDate, schoolEndDate);
       
        setLoading4(false);
        if (server_response.status === "OK") {
          setSchoolCharges(server_response.details);
        } else {
          setSchoolCharges("404");
        }
    };

    const getTotalVendorCharges = async () => {
      setLoading5(true);
        const server_response = await ajaxBank.fetchTotalWithdrawChargesForVendors();
        setLoading5(false);
        if (server_response.status === "OK") {
          setVendorCharges(server_response.details);
        } else {
          setVendorCharges("404");
        }
    };

    const searchTotalVendorCharges = async () => {
      setLoading6(true);
        const server_response = await ajaxBank.searchTotalWithdrawChargesForVendors(vendorStartDate, vendorEndDate);
        setLoading6(false);
        if (server_response.status === "OK") {
          setVendorCharges(server_response.details);
        } else {
          setVendorCharges("404");
        }
    };

    const getMMChargesToday = async () => {
        const server_response = await ajaxBank.fetchMMChargesToday();
        if (server_response.status === "OK") {
          setMMChargesToday(server_response.details);
        } else {
          setMMChargesToday("404");
        }
    };

    const getWithdrawChargeBalance = async () => {
      const server_response = await ajaxBank.fetchWithdrawChargeBalance();
     
      if (server_response.status === "OK") {
        setWithdrawChargeBalance(server_response.details);
      } else {
        setWithdrawChargeBalance("404");
      }
    };
    

    const setMMCharges = (e) => {
      e.preventDefault();
      setStartDate("");
      setEndDate("");
      getTotalMMCharges();
      
    };

    const setDepositCharges = (e) => {
      e.preventDefault();
      setSchoolStartDate("");
      setSchoolEndDate("");
      getTotalSchoolCharges();
      
    };

    const setVendorCharge = (e) => {
      e.preventDefault();
      setVendorStartDate("");
      setVendorEndDate("");
      getTotalVendorCharges();
      
    };

  return (
    <AppContainer title="Mobile Money Charges">
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
                          // Full page skeleton loader
                          <div style={{ padding: 40 }}>
                            <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                            <Skeleton height={200} style={{ marginBottom: 20 }} />
                            <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                          </div>
                        ) : (
      <div className="row">
        <div className="col-lg-5">
          <div className="row">
          <MMChargesToday mmChargesToday={mmChargesToday}/>
            <MMChargesTotal mmChargesTotal={mmChargesTotal} loading={loading} loading2={loading2}
            startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} searchMMCharges={searchTotalMMCharges}
            resetSearch={setMMCharges}/>
            <SchoolDepositChargesTotal depositCharges={schoolCharges} loading={loading3} loading2={loading4}
            startDate={schoolStartDate} setStartDate={setSchoolStartDate} endDate={schoolEndDate} setEndDate={setSchoolEndDate} searchDepositCharges={searchTotalSchoolCharges}
            resetSearch={setDepositCharges}/>
            <VendorWithdrawCharges withdrawCharges={vendorCharges} loading={loading5} loading2={loading6}
            startDate={vendorStartDate} setStartDate={setVendorStartDate} endDate={vendorEndDate} setEndDate={setVendorEndDate} searchWithdrawCharges={searchTotalVendorCharges}
            resetSearch={setVendorCharge}/>
          </div> 
        </div>
        
        <div className="col-lg-7">
          <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {withdrawChargeBalance? withdrawChargeBalance.total_c:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Current Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <MMChargesList/>
            

          </div>
        </div>

        
      </div>)}
    </AppContainer>
  );
}

export default MMChargesPage;
